import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { ClipboardListIcon, LinkIcon, SearchIcon, PlusCircleIcon, CheckCircleIcon } from 'lucide-react';
const Step = ({
  icon,
  title,
  description,
  isLast = false,
  isActive = false,
  isCompleted = false
}) => {
  return <motion.div className="flex items-center" initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2
  }} data-id="element-321">
      <div className="flex flex-col items-center" data-id="element-322">
        <motion.div className={`w-8 h-8 rounded-full flex items-center justify-center ${isCompleted ? 'bg-green-500' : isActive ? 'bg-blue-500' : 'bg-blue-100'}`} whileHover={{
        scale: 1.1
      }} whileTap={{
        scale: 0.95
      }} data-id="element-323">
          {isCompleted ? <CheckCircleIcon className="h-4 w-4 text-white" data-id="element-324" /> : <div className={`${isActive ? 'text-white' : 'text-blue-600'}`} data-id="element-325">
              {cloneElement(icon, {
            className: 'h-4 w-4'
          })}
            </div>}
        </motion.div>
        {!isLast && <motion.div className={`flex-1 w-px ${isCompleted ? 'bg-green-500' : 'bg-gray-200'} my-1`} initial={{
        height: 0
      }} animate={{
        height: '100%'
      }} transition={{
        duration: 0.3
      }} data-id="element-326" />}
      </div>
      <div className="ml-3 flex-1" data-id="element-327">
        <h4 className={`text-sm font-medium ${isActive ? 'text-blue-600' : 'text-gray-700'}`} data-id="element-328">
          {title}
        </h4>
        <p className="text-xs text-gray-500 mt-0.5" data-id="element-329">{description}</p>
      </div>
    </motion.div>;
};
const StepsGuide = () => {
  const currentStep = 1;
  const completedSteps = [0];
  return <motion.div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4 mb-6" initial={{
    opacity: 0,
    y: -10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} data-id="element-330">
      <div className="flex items-center justify-between mb-4" data-id="element-331">
        <h2 className="text-base font-medium text-gray-800" data-id="element-332">Quick Guide</h2>
        <div className="text-xs text-gray-500" data-id="element-333">Step {currentStep + 1} of 4</div>
      </div>
      <div className="space-y-4" data-id="element-334">
        <Step icon={<ClipboardListIcon data-id="element-336" />} title="Review Products" description="Check your Shopify product matches" isActive={currentStep === 0} isCompleted={completedSteps.includes(0)} data-id="element-335" />
        <Step icon={<LinkIcon data-id="element-338" />} title="Link Perfect Matches" description="Connect exact Amazon matches" isActive={currentStep === 1} isCompleted={completedSteps.includes(1)} data-id="element-337" />
        <Step icon={<SearchIcon data-id="element-340" />} title="Review Potential Matches" description="Verify suggested matches" isActive={currentStep === 2} isCompleted={completedSteps.includes(2)} data-id="element-339" />
        <Step icon={<PlusCircleIcon data-id="element-342" />} title="Create New Listings" description="Set up missing listings" isActive={currentStep === 3} isCompleted={completedSteps.includes(3)} isLast={true} data-id="element-341" />
      </div>
    </motion.div>;
};
export default StepsGuide;